<template>
  <div class="areaCascader">
    <el-cascader
      ref="areaCascader"
      v-model="values"
      :props="props"
      :show-all-levels="false"
      clearable
      collapse-tags
      @change="change"
      :placeholder="$l(title)"
      :filterable="filterable"
    ></el-cascader>
  </div>
</template>
<script>
export default {
  props: {
    multiple: {
      type: Boolean,
      default: false,
    },
    checkStrictly: {
      type: Boolean,
      default: false,
    },
    type: {
      type: Number,
      default: 1,
    },
    placeholder: {
      type: String,
      default: "所属城市",
    },
  },
  data() {
    return {
      props: {
        value: "id",
        label: "name",
        lazy: true,
        lazyLoad: this.loadNode,
        multiple: this.multiple,
        checkStrictly: this.checkStrictly,
      },
      values: [],
      title: "",
      filterable: true,
    };
  },
  watch: {
  },
  mounted() {
    this.title = this.placeholder;
  },
  methods: {
    //解决Cascader控件在IE11在filterable 状态下 CascaderPanel 初始化问题
    blur() {
      this.filterable = true;
    },
    loadNode(node, resolve) {
      const level = node.level;
      const pData = level == 0 ? null : node.data;
      let parentId = pData ? pData.id : null;
      const userType = this.$store.state.user.userType;
      this.$http
        .get(this.$apiConfig.get_account_data_permission_url, {
          params: {
            parentId: parentId,
            level: level,
            userType: userType,
          },
        })
        .then((response) => {
          const result = response.data;
          let datas = [];
          if (result.code == 0) {
            let data = result.data;
            if (data) {
              if (level == 4) {
                data.forEach((item, i) => {
                  item.leaf = true;
                });
              }
              data.forEach((item, i) => {
                item.level = level + 1;
                if (level > 0) {
                  let id = pData.ids;
                  let name = pData.names;
                  if (userType == 1) {
                    item.ids = id + item.id + ",";
                  } else {
                    if (level == 3) {
                      item.ids = id + item.id.split(",").pop() + ",";
                    } else {
                      item.ids = id + item.name + ",";
                    }
                  }
                  item.parentId =
                    userType == 1 ? pData.id : pData.id.split(",").pop();
                  item.parentName = pData.name;
                  item.names = name + "-" + item.name;
                } else {
                  item.ids = item.id + ",";
                  item.names = item.name;
                }
              });
              datas = data;
            }
          }
          resolve(datas);
        })
        .catch((error) => {
          this.$sentry.captureException(error);
          resolve([]);
        });
    },
    getShowLabel() {
      const nodes = this.$refs.areaCascader.getCheckedNodes();
      if (nodes && nodes.length > 0) {
        return nodes[0].label;
      }
      return "";
    },
    getSelectedList() {
      const nodes = this.$refs.areaCascader.getCheckedNodes();
      if (nodes.length > 0) {
        let idsArr = [];
        let tempIdsArr = nodes
          .filter((n) => n.level == 1)
          .map((n) => n.data.ids);
        tempIdsArr.forEach((ids, i) => {
          idsArr.push(ids);
        });
        let maxLevel = 5;
        for (let i = 2; i <= maxLevel; i++) {
          tempIdsArr = nodes.filter((n) => n.level == i).map((n) => n.data.ids);
          tempIdsArr.forEach((ids, ii) => {
            if (idsArr.filter((v) => ids.indexOf(v) == 0).length == 0) {
              idsArr.push(ids);
            }
          });
        }
        return idsArr;
      }
      return [];
    },
    change(values) {
      // if (!this.multiple && values.length != 5) {
      //   this.values = [];
      // }
    },
  },
};
</script>
<style lang="scss">
.areaCascader {
  /deep/ .el-cascader__tags {
    flex-wrap: nowrap;
    >:nth-child(2){
      display: none;
    }
  }
  /deep/ .el-cascader__tags .el-tag > span {
    flex: auto;
  }
  /deep/ .el-cascader__search-input {
    display: none;
  }
}

// .areaCascader {
//   .el-cascader {
//     width: 350px;
//     // input {
//     //   height: 28px !important;
//     // }
//     .el-input {
//       width: 350px;
//     }
//     .el-cascader__tags {
//       width: 350px;
//       // flex-wrap: nowrap;
//       // height: 32px;
//       .el-tag {
//         span {
//           width: 60px !important;
//         }
//         // display: none;
//       }
//     }
//   }
// }
</style>